import { useState } from "react";
import { useTranslation } from "react-i18next";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Tools from "@/assets/icons/Tools.svg";
import styles from "../profileList.module.scss";

interface TooltipComProps<T> {
  ProductItem: T;
  deleteFn: (item: T) => void;
}
const LightTooltip = styled(({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    padding: "13px 25px",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 28px 0px #00000014",
    fontSize: 14,
    color: "#1A1A1A",
    "&:hover": {
      color: "#FF3F4F",
    },
  },
}));
function TooltipCom<T>(props: TooltipComProps<T>) {
  const { t } = useTranslation();

  const { ProductItem, deleteFn } = props;
  const [open, setOpen] = useState(false);
  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleClickDelete = () => {
    deleteFn(ProductItem);
  };
  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <LightTooltip
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          placement="top"
          onClose={handleTooltipClose}
          title={
            <span className={styles.deleteText} onClick={() => handleClickDelete()}>
              {t("common.btnText.delete")}
            </span>
          }
        >
          <IconButton onClick={handleTooltipOpen}>
            <Tools className={styles.tools} width={20} height={20} />
          </IconButton>
        </LightTooltip>
      </div>
    </ClickAwayListener>
  );
}

export default TooltipCom;
